import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { agentBrokerTheme } from '@shared/antd-theme';
import { BuildInfo } from '@shared/BuildInfo';
import { ProductsPage } from './ProductsPage';

type Props = {
    userId?: string;
    csrf?: string;
};

export function App(_props: Props) {
    return (
        <ConfigProvider locale={ruRU} theme={agentBrokerTheme}>
            <ProductsPage />
            <BuildInfo />
        </ConfigProvider>
    );
}
